import { APPLICATION_QUESTION_OPTION_TEMPLATE_MODEL } from "@/models/application-question-option-template-model";
import pluralize from "pluralize";

export const APPLICATION_QUESTION_TEMPLATE_MODEL =
  "application-question-template";

const applicationQuestionTemplateModel = {
  question: "",
  organisationUnitId: "",
  bookingId: "",
  required: false,
  characterLimit: null,
  inputType: "",
  explanation: "",
  terms: [],
  optionsTemplate: [],
  options: {
    type: pluralize(APPLICATION_QUESTION_OPTION_TEMPLATE_MODEL),
    jsonApi: "hasMany"
  },
  organisation: {
    jsonApi: "hasOne",
    type: "organisations"
  }
};

export default applicationQuestionTemplateModel;
